import { useEffect, useState } from "react";
import { HiOutlineSearch } from "react-icons/hi";
import QuoteRequestModal from 'Components/Quote/QuoteRequestModal'
import { fetchQuoteRequests } from "API/quoteRequests.api";


const QuoteRequests = () => {

    const [open, setOpen] = useState(false);
    const [selectedQuote, setSelectedQuote] = useState({});
    const [quoteList, setQuoteList] = useState([]);
    const [searchText, setSearchText] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [completeFilterFlag, setCompleteFilterFlag] = useState(true);




    const handleSearch = (text) => {
        if (!text) {
            setFilteredList(quoteList);
            setCompleteFilterFlag(true)
            return;
        }
        setCompleteFilterFlag(false);

        const result = quoteList.filter((item) =>
            item.id.toString().includes(text)
        );

        setFilteredList(result);
        console.log("This is result",result)
        console.log("This is the filtered List ", filteredList)
        console.log(text)
        console.log(searchText)

    };

    // Passing this function to Modal to refresh the list once chnges has been done

    const refreshList = () => {
        setQuoteList(quoteList);
    }


    useEffect(() => {

        const getQuoteList = async () => {
            const response = await fetchQuoteRequests();
            if (response) {
                setQuoteList(response);
            }
            setQuoteList(response);
            setFilteredList(response);

        }

        // Uncomment below line and remove the dummy data
        // getQuoteList() 

        getQuoteList()

    }, [])






    // const filteredQuotes = quoteList.filter((quote) =>
    //     quote.reference.toLowerCase().includes(search.toLowerCase())
    // );

    return (
        <div className="w-[95%] space-y-6 mt-4 m-auto mx-4">


            <div>
                <h1 className="text-2xl  text-center font-semibold text-gray-900">
                    Manage Your Quote Requests
                </h1>
                <p className="mt-1 text-sm text-center text-gray-600">
                    This is your quote request list. Click on a row to view full request details.
                </p>
            </div>


            <div className="relative">
                <HiOutlineSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

                <input
                    onChange={(e) => {
                        const searchValue = e.target.value;
                        setSearchText(searchValue);
                        handleSearch(searchValue);
                    }}
                    type="text"
                    placeholder="Search by quote reference..."
                    className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-3 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
            </div>


            <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm relative w-full  mx-auto">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 text-left text-gray-600">
                        <tr>
                            <th className="px-4 py-3">Quote ID</th>
                            <th className="px-4 py-3">Client Name</th>
                            <th className="px-4 py-3">Vehicle</th>
                            <th className="px-4 py-3">Status</th>
                            <th className="px-4 py-3">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {quoteList.length > 0 ? (
                            filteredList.filter((quote) => (completeFilterFlag ?  quote.status !== "completed":true )).map((quote, index) => (
                                <tr
                                    key={quote.id}
                                    className="cursor-pointer border-t hover:bg-gray-50"
                                >

                                    <td className="px-4 py-3 font-medium text-blue-600">
                                        {quote.id}
                                    </td>

                                    <td className="px-4 py-3 font-medium">
                                        {quote.client.name}
                                    </td>

                                    <td className="px-4 py-3">
                                        {quote.vehicle.year} {quote.vehicle.make} {quote.vehicle.model}
                                    </td>
                                    <td className="px-4 py-3">
                                        {quote.status}
                                    </td>


                                    <td className="px-4 py-3">
                                        <button
                                            onClick={() => {
                                                setSelectedQuote(quote);
                                                setOpen(true);
                                            }}
                                            className="mx-1 flex items-center gap-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="px-4 py-6 text-center text-gray-500">
                                    No quote request found
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>
            <QuoteRequestModal open={open} data={selectedQuote} onClose={() => { setOpen(false) }} refresh={() => { refreshList() }} />
        </div>
    );
};

export default QuoteRequests;
